const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const EMAIL_MIN_LENGTH = 5;
const EMAIL_MAX_LENGTH = 254;

export const isValidEmail = (email: string): boolean => {
  return EMAIL_REGEX.test(email);
};

export const sanitizeEmail = (input: string): string => {
  return input.trim().slice(0, EMAIL_MAX_LENGTH);
};

export const validateEmail = (email: string): { isValid: boolean; error?: string } => {
  if (!email) {
    return { isValid: false, error: 'email_required' };
  }

  const sanitized = sanitizeEmail(email);

  if (!isValidEmail(sanitized)) {
    return { isValid: false, error: 'email_invalid' };
  }

  if (sanitized.length < EMAIL_MIN_LENGTH || sanitized.length > EMAIL_MAX_LENGTH) {
    return { isValid: false, error: 'email_invalid' };
  }

  return { isValid: true };
};
